
import CurrencyConverter from "../common/currency-converter.vue";
import orderDetailsItemDetailsRowNameSpan from "./order-details-item-details-row-name-span.vue";
export default {
  components: { orderDetailsItemDetailsRowNameSpan, CurrencyConverter },
  props: {
    item: {
      default: {}
    },
    isAvailabilityToggleShown: {
      type: Boolean,
      default: false
    },
    isModificationEnabled: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: ""
    },
    quantity: "",
    isNewOrderDialog: {
      type: Boolean,
      default: false
    },
    isOrderDetails: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      availabilitySwitch: true
    };
  },
  created() {
    this.$nuxt.$on("availability-toggled-on", () => {
      this.availabilitySwitch = true;
    });
  },
  computed: {
    isComboItem() {
      return !!this.item.items?.length;
    },
    getItemPrice() {
      return (
        (this.isComboItem ? this.item.amount : this.item.unit_price) *
        (this.isComboItem ? this.item.combo_quantity : this.item.quantity)
      );
    }
  },
  methods: {
    handleSwitchToggle(val) {
      const payload = {
        orderId: this.orderId,
        itemId: this.isComboItem
          ? String(`combo-${this.item.id}`)
          : String(this.item.id),
        isAvailable: val
      };
      this.$nuxt.$emit("availability-toggled", payload);
    }
  }
};
